<template>
  <DrawerComponent
    :open="navStore.navigationIsOpen"
    :open-left="true"
    @change-open="navStore.setNavigationIsOpen(false)"
  >
    <template #content>
      <SideBar />
    </template>
  </DrawerComponent>
</template>
<script setup lang="ts">
import { useNavigationStore } from '@/stores/portal-stores/component-stores/navigation'

const navStore = useNavigationStore()
</script>
